import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const PersonRunningIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M14.6 6C15.7 6 16.6 5.1 16.6 4C16.6 2.9 15.7 2 14.6 2C13.5 2 12.6 2.9 12.6 4C12.6 5.1 13.5 6 14.6 6ZM11 19.9L12 15.5L14.1 17.5V23.5H16.1V16L14 14L14.6 11C15.9 12.5 17.9 13.5 20.1 13.5V11.5C18.2 11.5 16.6 10.5 15.8 9.1L14.8 7.5C14.4 6.9 13.8 6.5 13.1 6.5C12.8 6.5 12.6 6.6 12.3 6.6L7.1 8.8V13.5H9.1V10.1L10.9 9.4L9.3 17.5L4.4 16.5L4 18.5L11 19.9Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
